module.exports = __webpack_public_path__ + "static/media/communityIcon.96df0352.png";